module.exports = __webpack_public_path__ + "img/fangan3.4b25a0dc.png";